const formatMobileNumberToDisplay = (number) => {
	if (!number) return "";
	return `${number.substring(0, 4)} ${number.substring(
		4,
		7,
	)} ${number.substring(7, 10)}`;
};

export default formatMobileNumberToDisplay;
